// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/timeline/timelineCtrl.js#1 $
angular.module('tcApp')
.controller('TimelineCtrl', function($scope, $window, $routeParams, $mdUtil, $mdMedia, $timeout,
										SystemRouter, TimelineService, LegacyScopeService, $interval) {
	var d3 = $window.window.d3;
	var self = this;
	
	// promise for any pending data fetches (set in showNewTimeWindow)
	// used to detect if a fetch is already pending, to prevent multiple fetches
	// from happening at once, which can have weird side effects
	this.fetchPromise = null;

	var legacyFunctions = LegacyScopeService.getLegacyFunctions($scope);
	var JSDateToDateTime$H = legacyFunctions.JSDateToDateTime$H;
	var DateTime$HToJSDate = legacyFunctions.DateTime$HToJSDate;
	var websysSetValue = legacyFunctions.websys_setValue;
	var websysGetValue = legacyFunctions.websys_getValue;
	var websysCallFunction = legacyFunctions.websys_callFunction;

	var maxAutoRefreshInterval = 14400000; // 4 hours in JS Time
	
	// setup d3 objects and consants
	var initialiseController = function() {
		var brushMargin = 10;
		var showLegend = ($scope.data.disableLegend) || ($scope.data.showLegend && $mdMedia('gt-md'));
		$scope.viewModel = {
			brushDimensions: {
				margin: brushMargin,
				marginTop: 0,
				width: 230 - (brushMargin * 2),
				height: 20
			},
			JSTimeFrom: $scope.data.JSTimeFrom,
			JSTimeTo: $scope.data.JSTimeTo,
			brushDomainStartTime: $scope.data.JSQueryTimeFrom,
			brushDomainEndTime: $scope.data.JSQueryTimeTo,
			dataJSTimeFrom: $scope.data.JSQueryTimeFrom,
			dataJSTimeTo: $scope.data.JSQueryTimeTo,
			// timeFrom/To passed to timeline items (separate to avoid timing issues with data retrieval)
			ItemTimeFrom: $scope.data.JSTimeFrom,
			ItemTimeTo: $scope.data.JSTimeTo,
			defaultTimeSettings: $scope.data.defaultTimeSettings,
			showLegend: showLegend,
			disableLegend: $scope.data.disableLegend,
			lastInterval: $scope.data.interval.value,
			relativeMarkersBaseJSTime: $scope.data.relativeMarkersBaseJSTime,
			relativeMarkersLineJSTime: ($scope.data.useGestation
										? $scope.data.dobJSTime : $scope.data.relativeMarkersBaseJSTime),
			autoRefresh: {
				enabled: $scope.data.autoRefreshEnabled,
				lock: true,
				smallInterval: true,
				popoverInactive: true,
				userPrefInactive: true
			},
			initScrollCount: 0,
		};
		
		$scope.viewModel.brush = d3.brushX()
			.extent([[0,0], [$scope.viewModel.brushDimensions.width, $scope.viewModel.brushDimensions.height]]);
					
		$scope.viewModel.brushScale = d3.scaleTime().range([0, $scope.viewModel.brushDimensions.width])
			.domain([$scope.data.JSQueryTimeFrom, $scope.data.JSQueryTimeTo]);

		var fromEncounterRecord = websysGetValue('TimelineID','epr.UPR.Composite');

		// selection saved in auto-refresh
		if (angular.isDefined($scope.data.selectedTime) && ($scope.data.selectedTime !== '')) {
			$scope.viewModel.selectedTime = DateTime$HToJSDate($scope.data.selectedTime);
			websysSetValue('SelectedDateTime', $scope.data.selectedTime, 'system.Timeline');
		}
		
		// initialize auto-refresh
		$scope.viewModel.lastRefresh = getCurrentTime();
		if (($scope.viewModel.autoRefresh.enabled) && (fromEncounterRecord !== '')) {
			$scope.viewModel.autoRefresh.interval = $scope.data.autoRefreshInterval;
			$scope.viewModel.autoRefresh.on = $scope.data.autoRefreshOn;
			// check for auto-refresh every 5 seconds.
			// At the time of writing this, the minimum interval is 5 minutes so it doesn't need to be very responsive
			$scope.viewModel.autoRefresh.timer = $interval($scope.triggerAutoRefresh,5000);
		} else if (fromEncounterRecord === '') {
			// no user preferences so set all timeline items to be open by default 
			angular.forEach($scope.data.items, function(item) { 
				item.collapsed = false;
				item.hidden = false;
			});
		}
		if ($scope.data.interval.JSTime > maxAutoRefreshInterval) {
			$scope.pauseAutoRefresh({reason: 'LargeInterval'});
		}
		// call playAutoRefresh on epr.UPR.Composite, for cases where auto refresh data on component needs to be reinitialized
		// i.e. user clicks on popover link (auto-pauses) then breadcrumbs back to timeline (plays again)
		$scope.playAutoRefresh(undefined, true);
	};
	
	// Called on init and any time time header svg width needs to change (resize, legendToggle)
	this.setTimeHeaderDimensions = function() {
		var timeHeaderWidth = $scope.getTimeHeaderWidthFromContainer();
		
		$scope.viewModel.timeHeaderWidth = timeHeaderWidth;
		$scope.viewModel.timeHeaderDimensions = 
			TimelineService.getTimelineDimensions($scope.data.showRelativeMarkers, $scope.viewModel.timeHeaderWidth);
						
		// setup d3 scale and axis based on initial time data and dimensions
		var xScale = d3.scaleTime().rangeRound([0, $scope.viewModel.timeHeaderDimensions.width]);
		$scope.viewModel.xScale = xScale;
		self.updateTimeWindow($scope.viewModel.JSTimeFrom, $scope.viewModel.JSTimeTo);
		
		var xAxis = d3.axisTop($scope.viewModel.xScale)
			.ticks(TimelineService.getAxisTicks($scope.data.interval.value))
			.tickFormat(function(d) {
				if (self.getVisibleTimeColumnCount() > 18) {
					// calculate columnIndex based on brushDomainStartTime to hide odd ticks
					// Can't use index provided by axis as this causes hidden ticks to alternate as we scroll
					var scrollableStartTime = $scope.viewModel.brushDomainStartTime;
					var tickTimeDiff = d.getTime() - scrollableStartTime;
					var offset = tickTimeDiff % $scope.data.interval.JSTime;
					var columnIndex = (((d.getTime() - offset) - scrollableStartTime) / $scope.data.interval.JSTime);
					if (columnIndex % 2 !== 0) return '';
				}
				return TimelineService.formatTick(d, $scope.data.interval.value);
			})
			.tickSize(0);
		$scope.viewModel.xAxis = xAxis;
		
		// initialise x axis for time column super headings
		var superHeadingXAxis = d3.axisTop($scope.viewModel.xScale)
			.ticks(TimelineService.getSuperHeadingTicks($scope.data.interval.value))
			.tickFormat(function(d) {
				return TimelineService.formatSuperHeadingTick(d, $scope.data.interval.value);
			})
			.tickSize(0);
		$scope.viewModel.superHeadingXAxis = superHeadingXAxis;
		
		if ($scope.data.showRelativeMarkers) {
			// initialise x axis for time column super headings	
			var relativeMarkersXAxis = d3.axisTop($scope.viewModel.xScale)
				.tickFormat(function(d) {
					return TimelineService.formatRelativeTimeMarker(d, $scope.data.interval,
						$scope.viewModel.relativeMarkersBaseJSTime, $scope.data.useGestation,
						$scope.data.isProblemTimeline, $scope.data.defaultRelativeMarkerInterval);
				})
				.tickSize(-($scope.viewModel.timeHeaderDimensions.timeHeaderHeight
					+ $scope.viewModel.timeHeaderDimensions.relativeTimeOffset));
			$scope.viewModel.relativeMarkersXAxis = relativeMarkersXAxis;
		}
		
	};

	// Called when brush is moved, updates current TimeFrom/To
	this.onBrush = function() {
		if ((d3.event.sourceEvent) && (d3.event.sourceEvent.type !== 'mousemove')
			&& (d3.event.sourceEvent.type !== 'touchmove')) return;
		// only do this if brush was moved by the user
		if (d3.event.sourceEvent) {
			var selection = d3.event.selection || $scope.viewModel.brushScale.range();
			var range = selection.map($scope.viewModel.brushScale.invert, $scope.viewModel.brushScale);
			var timeFrom = range[0].getTime();
			var timeTo = range[1].getTime();
			
			$scope.restyleBrushSelection();
			if (timeFrom != $scope.viewModel.JSTimeFrom) {
				self.setBrushValues(timeFrom, timeTo);
				$scope.$digest();
			}
		}
	};
	
	// Called when brush is selected
	this.onBrushStart = function() {
		$scope.restyleBrushSelection();	
	};
	
	// Set the time window using default values stored in viewModel on instantiation
	this.resetToDefault = function() {
		var defaults = $scope.viewModel.defaultTimeSettings;
		var displayTimeFrom = defaults.displayTimeFrom;
		var displayTimeTo = defaults.displayTimeTo;
		var windowTimeFrom = defaults.windowTimeFrom;
		var windowTimeTo = defaults.windowTimeTo;
		var interval = defaults.interval; 
		
		self.setBrushValues(displayTimeFrom, displayTimeTo, windowTimeFrom, windowTimeTo);
		$scope.data.interval = interval;

		if ($scope.data.interval.JSTime > maxAutoRefreshInterval) {
			$scope.pauseAutoRefresh({reason: 'LargeInterval'});
		} else {
			$scope.playAutoRefresh({reason: 'LargeInterval'});
		}

		websysCallFunction('system.Timeline.Interval','SetIntervalValue',[interval.desc,interval.value]); // Update the value of the interval lookup
	};

	$scope.getCacheValues = function() {
		var cacheData = {};
		cacheData.interval = '';
		cacheData.JSTimeFrom = '';
		cacheData.JSTimeTo = '';
		cacheData.queryTimeFrom = '';
		cacheData.queryTimeTo = '';
		cacheData.autoRefreshInterval = $scope.viewModel.autoRefresh.interval;
		cacheData.autoRefreshOn = +$scope.viewModel.autoRefresh.on;
			
		if (!$scope.disableResetToDefault()) {
			cacheData.interval = $scope.data.interval.value;
			cacheData.JSTimeFrom = $scope.viewModel.JSTimeFrom;
			cacheData.JSTimeTo = $scope.viewModel.JSTimeTo;
			cacheData.queryTimeFrom = $scope.viewModel.brushDomainStartTime;
			cacheData.queryTimeTo = $scope.viewModel.brushDomainEndTime;
		}
		cacheData.episodeId = $scope.data.episodeId;
		cacheData.timelineId = $scope.data.timelineId;
		cacheData.scrollY = $scope.data.cachedScrollY;

		return cacheData;
	};

	// saves the current interval and time domain to a component item to be passed during auto refreshes
	this.passCacheValues = function() {
		var cacheData = $scope.getCacheValues();
		websysSetValue('CacheValues', angular.toJson(cacheData), 'system.Timeline');
	};
	
	// update brush selection and optionally brush domain. Should be used in favor of explicit calls to brush.move
	this.setBrushValues = function(selectionTimeFrom, selectionTimeTo, domainTimeFrom, domainTimeTo) {
		if (!isValidBrushMove(selectionTimeFrom, selectionTimeTo, domainTimeFrom, domainTimeTo)) return;
		
		if (angular.isUndefined(selectionTimeFrom)) selectionTimeFrom = $scope.viewModel.JSTimeFrom;
		if (angular.isUndefined(selectionTimeTo)) selectionTimeTo = $scope.viewModel.JSTimeTo;
		if (angular.isUndefined(domainTimeFrom)) domainTimeFrom = $scope.viewModel.brushDomainStartTime;
		if (angular.isUndefined(domainTimeTo)) domainTimeTo = $scope.viewModel.brushDomainEndTime;
		
		// round values to nearest whole number
		selectionTimeFrom = Math.round(selectionTimeFrom);
		selectionTimeTo = Math.round(selectionTimeTo);
		domainTimeFrom = Math.round(domainTimeFrom);
		domainTimeTo = Math.round(domainTimeTo);
		
		$scope.viewModel.brushScale.domain([domainTimeFrom, domainTimeTo]);
		
		$scope.viewModel.JSTimeFrom = selectionTimeFrom;
		$scope.viewModel.JSTimeTo = selectionTimeTo;
		
		if ((domainTimeFrom === $scope.viewModel.brushDomainStartTime)
			&& (domainTimeTo === $scope.viewModel.brushDomainEndTime) && (self.fetchPromise === null)) {
			// Don't update item times if we're awaiting data from the server,
			// or if we may be about to make a server call (because brush domain has changed)
			$scope.viewModel.ItemTimeFrom = selectionTimeFrom;
			$scope.viewModel.ItemTimeTo = selectionTimeTo;
		}
		
		$scope.viewModel.brushDomainStartTime = domainTimeFrom;
		$scope.viewModel.brushDomainEndTime = domainTimeTo;

		self.passCacheValues();
	};
	
	// return xScale pixel coordinate from time
	this.getXCoordinateFromTime = function(time) {
		return $scope.viewModel.xScale(time);	
	};
	
	// return number of time columns based on timefrom/to and interval
	this.getVisibleTimeColumnCount = function() {
		var displayTimeDiff = $scope.viewModel.JSTimeTo - $scope.viewModel.JSTimeFrom;
		var columnCount = (displayTimeDiff / $scope.data.interval.JSTime);
		
		return columnCount;
	};
	
	// Sets the selected time in the view model corresponding to the position in the header that was clicked 
	// and broadcasts it to the graphs
	this.headerClick = function(target) {
		var coords = d3.mouse(target);
		var xcoord = coords[0];
		var xcoordTime = $scope.viewModel.xScale.invert(xcoord);
		$scope.viewModel.selectedTime = xcoordTime;
		var SelectedDateTime = JSDateToDateTime$H(xcoordTime, false);
		websysSetValue('SelectedDateTime', SelectedDateTime, 'system.Timeline');
		$scope.$broadcast('Timeline:headerClick', xcoordTime);
		return xcoordTime;
	};
	
	// Deselects the time cursor
	this.cursorCloseClick = function() {
		$scope.viewModel.selectedTime = undefined;
		websysSetValue('SelectedDateTime', '', 'system.Timeline');
		$scope.$broadcast('Timeline:headerUnselect'); // For observation and administration timelines
	};

	// called from setBrushValues before updating to ensure new values will be valid
	var isValidBrushMove = function(selectionTimeFrom, selectionTimeTo, domainTimeFrom, domainTimeTo) {
		var valid = true;
		var selectionFromCheck = (selectionTimeFrom ? selectionTimeFrom : $scope.viewModel.JSTimeFrom);
		var selectionToCheck = (selectionTimeTo ? selectionTimeTo : $scope.viewModel.JSTimeTo);
		var domainFromCheck = (domainTimeFrom ? domainTimeFrom : $scope.viewModel.brushDomainStartTime);
		var domainToCheck = (domainTimeTo ? domainTimeTo : $scope.viewModel.brushDomainEndTime);
		
		// ensure selection is within domain
		if ((selectionFromCheck < domainFromCheck) || (selectionToCheck > domainToCheck)) {
			valid = false;
		}
		// ensure selection and domain are positive and non-zero
		if ((selectionToCheck <= selectionFromCheck) || (domainToCheck <= selectionFromCheck)) {
			valid = false;
		}
		
		return valid;
		
	};
	
	// Gets the next interval after zooming in or out by changing
	// the interval sequence value by sequenceChangeAmount (usually +1 or -1)
	var getNextInterval = function(sequenceChangeAmount) {
		var currentInterval = $scope.data.interval;
		var nextIntervalIndex = currentInterval.sequence + sequenceChangeAmount;
		return getInterval(nextIntervalIndex);
	};


	// Gets the interval from interval index
	var getInterval = function(IntervalIndex) {
		if (angular.isDefined($scope.data.intervals[IntervalIndex])) {
			return $scope.data.intervals[IntervalIndex];
		}
	};

	// Gets the current interval
	$scope.getCurrentInterval = function() {
		return [$scope.data.interval.desc,$scope.data.interval.value];
	};
	// sets both the visible and scrollable time window and optionally the interval, loading new data if necessary
	this.showNewTimeWindow = function(newTimeFrom, newTimeTo, newDomainTimeFrom, newDomainTimeTo, newInterval) {
		if (self.fetchPromise !== null) {
			// if a fetch is already in progress, mark it to be disregarded and clear fetchPromise
			self.fetchPromise.invalid = true;
			self.fetchPromise = null;
		}
		// If new scrollable time range is outside data we've already loaded, fetch new data
		if ((newDomainTimeFrom < $scope.viewModel.dataJSTimeFrom) 
			|| (newDomainTimeTo > $scope.viewModel.dataJSTimeTo) || ($scope.data.dataHidden)
			|| ((($scope.data.hasClinicalProfile) || ($scope.data.hasObsProfile))
				&& ($scope.data.interval.value !== $scope.viewModel.lastInterval))) {
			var interval = newInterval ? newInterval : $scope.data.interval;
			var inEncounterRecord = $scope.isInEncounterRecord() ? 1 : '';
			var extraParameters = angular.extend({}, 
				$routeParams,
				{AcrossEpisodes: $scope.data.acrossEpisodes, CONTEXT: $scope.data.context, IsUPR: inEncounterRecord});
			// local variable thisFetch keeps this promise in scope for the .then below,
			// even if fetchPromise (set below the .then block) is cleared
			var thisFetch = SystemRouter.fetchTimelineItemsData($scope.data.timelineId,
				newDomainTimeFrom, newDomainTimeTo, interval.value, $scope.data.JSTimeNow, extraParameters)
				.then(function(response) {
					if (thisFetch.invalid) return;
					self.fetchPromise = null;
					if (angular.isDefined(response.data.items)) {
						angular.forEach(response.data.items, function(timelineItem, timelineItemIndex) {
							if ((timelineItem.profileType !== TimelineService.AdminTimelineType) && 
								(timelineItem.profileType !== TimelineService.ObsTimelineType)) {
								
								$scope.data.items[timelineItemIndex].dataHidden = timelineItem.dataHidden;
								if (timelineItem.profileType === TimelineService.GraphType) {
									$scope.data.items[timelineItemIndex].dataHiddenDueToType = timelineItem.dataHiddenDueToType;
									$scope.data.items[timelineItemIndex].dataHiddenDueToUOM = timelineItem.dataHiddenDueToUOM;
								}
								
								angular.forEach(timelineItem.axisGroups, function(axisGroup, axisGroupIndex) {
									$scope.data.items[timelineItemIndex]
										.axisGroups[axisGroupIndex].dataHidden = axisGroup.dataHidden;
									$scope.data.items[timelineItemIndex].axisGroups[axisGroupIndex].steps = axisGroup.steps;
									angular.forEach(axisGroup.yAxes, function(axis, axisIndex) {
										var yAxes = $scope.data.items[timelineItemIndex]
													.axisGroups[axisGroupIndex].yAxes[axisIndex];
										yAxes.dataHidden = axis.dataHidden;
										yAxes.axisMin = axis.axisMin;
										yAxes.axisMax = axis.axisMax;
										yAxes.axisStep = axis.axisStep;
										yAxes.steps = axis.steps;
										if (timelineItem.profileType === TimelineService.GraphType) {
											angular.forEach(axis.items, function(axisItem, axisItemIndex) {
												var yAxesItem = $scope.data.items[timelineItemIndex]
														.axisGroups[axisGroupIndex].yAxes[axisIndex].items[axisItemIndex];
												yAxesItem.dataHidden = axisItem.dataHidden;
												yAxesItem.dataTimes = axisItem.dataTimes;
												yAxesItem.outOfRangeData = axisItem.outOfRangeData;
												yAxesItem.orders = axisItem.orders;
												yAxesItem.itemType = axisItem.itemType;
											});
										}
										if ((timelineItem.profileType === TimelineService.EventTimelineType)
											|| (timelineItem.profileType === TimelineService.OrderTimelineType)) {
											$scope.data.items[timelineItemIndex].axisGroups[axisGroupIndex]
												.yAxes[axisIndex].items = axis.items;
										}
									});
								});
							} else {
								// preserve the user preference information
								timelineItem.collapsed = $scope.data.items[timelineItemIndex].collapsed;
								timelineItem.hidden = $scope.data.items[timelineItemIndex].hidden;
								timelineItem.sortOrder = $scope.data.items[timelineItemIndex].sortOrder;
								$scope.data.items[timelineItemIndex] = timelineItem;
							}
						});
						$scope.viewModel.dataJSTimeFrom = newDomainTimeFrom;
						$scope.viewModel.dataJSTimeTo = newDomainTimeTo;
						if (angular.isDefined(newInterval)) {
							$scope.data.interval = newInterval;
						}
						$scope.data.dataHidden = response.data.dataHidden;
						self.setBrushValues(newTimeFrom, newTimeTo, newDomainTimeFrom, newDomainTimeTo);
					}
				});
			self.fetchPromise = thisFetch;
		} else {
			if (angular.isDefined(newInterval)) {
				$scope.data.interval = newInterval;
			}
			self.setBrushValues(newTimeFrom, newTimeTo, newDomainTimeFrom, newDomainTimeTo);
		}	
	};
	
	// Jumps to the next page - a time window adjacent to the previous
	// time window and of equal size - in the specified direction
	var page = function(direction) {
		var brushTimeRange = $scope.viewModel.brushDomainEndTime - $scope.viewModel.brushDomainStartTime;
		var newBrushDomainTimeFrom = (direction === 'L' ? $scope.viewModel.brushDomainStartTime - brushTimeRange :
										$scope.viewModel.brushDomainEndTime);
		var newBrushDomainTimeTo = (direction === 'L' ? $scope.viewModel.brushDomainStartTime :
									$scope.viewModel.brushDomainEndTime + brushTimeRange);
		
		var visibleTimeRange = $scope.viewModel.JSTimeTo - $scope.viewModel.JSTimeFrom;
		var newDisplayTimeFrom = (direction === 'L' ? newBrushDomainTimeTo - visibleTimeRange :
										newBrushDomainTimeFrom);
		var newDisplayTimeTo = (direction === 'L' ? newBrushDomainTimeTo :
									newBrushDomainTimeFrom + visibleTimeRange);
		
		self.setBrushValues(newDisplayTimeFrom, newDisplayTimeTo, newBrushDomainTimeFrom, newBrushDomainTimeTo);
	};
	
	// Sets domain for xScale, accounting for time direction
	this.updateTimeWindow = function(timeFrom, timeTo) {
		// Scale the range of the data, inverting for Right to Left time
		if ($scope.data.timeDirection === 'RL') {
			$scope.viewModel.xScale.domain([timeTo,timeFrom]);	
		} else {
			$scope.viewModel.xScale.domain([timeFrom,timeTo]);
		}
		
		// Recalculates axis ticks for each axis
		if (angular.isFunction($scope.viewModel.xAxis)) {
			$scope.viewModel.xAxis.ticks(TimelineService.getAxisTicks($scope.data.interval.value));
		}
		
		if (angular.isFunction($scope.viewModel.superHeadingXAxis)) {
			$scope.viewModel.superHeadingXAxis.ticks(TimelineService.getSuperHeadingTicks($scope.data.interval.value));
		}
		
		if (angular.isFunction($scope.viewModel.relativeMarkersXAxis)) {
			$scope.viewModel.relativeMarkersXAxis.tickValues(getRelativeTimeMarkersTicks($scope.data.isProblemTimeline));
		}
		
		// Calculate number of columns: divide graphing area by number of columns
		var columnWidth = ($scope.viewModel.xScale.range()[1] / self.getVisibleTimeColumnCount()) - 1;
		$scope.viewModel.columnWidth = columnWidth;	
	};
	
	// Return array of times for relative markers within the brushable window
	var getRelativeTimeMarkersTicks = function(isProblemTimeline) {
		var markers = [];

		// If base time is after the end of our brushable window, no need to show any markers
		if ($scope.viewModel.brushDomainEndTime < $scope.viewModel.relativeMarkersBaseJSTime) {
			return [];
		}

		// for a problem timeline set ticks to be at axis tick locations instead of being offset from start time / DOB
		if (isProblemTimeline) {
			var startTime = Math.max($scope.viewModel.relativeMarkersBaseJSTime, $scope.viewModel.brushDomainStartTime);
			markers = TimelineService.getTicksInRange($scope.data.interval.value, startTime, $scope.viewModel.brushDomainEndTime);
			if (self.getVisibleTimeColumnCount() > 18) {
				markers = markers.filter(function(element, index) {
					return index % 2 === 0;
				});
			}
			return markers;
		}

		var intervalTime = $scope.data.interval.JSTime;
		var firstOffsetCount = 0;
		// if base time in the past, find the number of offsets out of our current brushable window
		if ($scope.viewModel.brushDomainStartTime > $scope.viewModel.relativeMarkersBaseJSTime) {
			var relativeBaseOffset = $scope.viewModel.brushDomainStartTime - $scope.viewModel.relativeMarkersBaseJSTime;
			var outOfViewOffsets = Math.floor(relativeBaseOffset / intervalTime); 
			firstOffsetCount = outOfViewOffsets + 1;
		}
		
		var increment = 1;
		if (self.getVisibleTimeColumnCount() > 18) {
			increment = 2;
			if (firstOffsetCount % 2 !== 0) firstOffsetCount += 1;
		}
		var nextTime = $scope.viewModel.relativeMarkersBaseJSTime + (firstOffsetCount * intervalTime);
		while (nextTime < $scope.viewModel.JSTimeTo) {
			if (nextTime >= $scope.viewModel.brushDomainStartTime) {
				markers.push(nextTime);
			}
			nextTime = nextTime + (increment * intervalTime);
		}
		
		return markers;
	};
	
	// Move brush to beginning of available window
	var jumpToWindowStart = function() {
		var visibleWindowStartOffset = $scope.viewModel.JSTimeFrom - $scope.viewModel.brushDomainStartTime;
		var newTimeFrom = $scope.viewModel.brushDomainStartTime;
		var newTimeTo = $scope.viewModel.JSTimeTo - visibleWindowStartOffset;
		self.setBrushValues(newTimeFrom, newTimeTo);
	};
	
	// Move brush to end of available window
	var jumpToWindowEnd = function() {
		var visibleWindowEndOffset =  $scope.viewModel.brushDomainEndTime - $scope.viewModel.JSTimeTo;
		var newTimeFrom = $scope.viewModel.JSTimeFrom + visibleWindowEndOffset;
		var newTimeTo = $scope.viewModel.brushDomainEndTime;
		self.setBrushValues(newTimeFrom, newTimeTo);	
	};
	
	// Checks if legend should be toggled off on resize
	this.toggleLegendOnResize = function() {
		if ((!$scope.viewModel.legendsToggled) && ($scope.data.showLegend)) {
			$scope.viewModel.showLegend = $mdMedia('gt-md');
			if ($scope.data.disableLegend === true)  $scope.viewModel.showLegend = true;
		}
	};
	
	// update time from/to in $scope.data so that viewing the component data
	// accurately reflects the current state of the timeline
	this.updateDataJSTimes = function() {
		$scope.data.JSTimeFrom = $scope.viewModel.JSTimeFrom;
		$scope.data.JSTimeTo = $scope.viewModel.JSTimeTo;
	};
	
	// update window time from/to in $scope.data so that viewing the component data
	// accurately reflects the current state of the timeline
	// Note: window time from/to is not the same as query time from/to,
	//  but no distinction is made in the component data (because it's pulled
	//  directly from the server, where the distinction doesn't matter), so just 
	//  setting the query times for now; may want to consider adding window times
	//  to the data from the server at some point in the future
	this.updateDataJSQueryTimes = function() {
		$scope.data.JSQueryTimeFrom = $scope.viewModel.brushDomainStartTime;
		$scope.data.JSQueryTimeTo = $scope.viewModel.brushDomainEndTime;
	};
	
	// updates viewModel values with the values from $scope.data
	this.updateViewModelFromData = function() {
		var displayTimeFrom = $scope.data.JSTimeFrom;
		var displayTimeTo = $scope.data.JSTimeTo;
		var windowTimeFrom = $scope.data.JSQueryTimeFrom;
		var windowTimeTo = $scope.data.JSQueryTimeTo;
		
		// assume new data has been bound in from the parent scope,
		// so update dataJSTimes to reflect this
		$scope.viewModel.dataJSTimeFrom = windowTimeFrom;
		$scope.viewModel.dataJSTimeTo = windowTimeTo;
		
		self.setBrushValues(displayTimeFrom, displayTimeTo, windowTimeFrom, windowTimeTo);
	};
	
	// Rescale to the next or previous time interval
	$scope.zoom = function($event, sequenceChangeAmount) { 
		var nextInterval = getNextInterval(sequenceChangeAmount);
		if (angular.isDefined(nextInterval)) {
			zoomTo(nextInterval);
			websysCallFunction('system.Timeline.Interval','SetIntervalValue',[nextInterval.desc,nextInterval.value]);
		}
		
	};
	
	// Logic for Rescale visible window and brush range based around current middle point based on new interval and # of columns
	var zoomTo = function(nextInterval) {
		if (angular.isDefined(nextInterval)) {
			var columnCount = self.getVisibleTimeColumnCount();
			var newTimeOffset = (nextInterval.JSTime * (columnCount / 2.0));
			var middleJSTime;
			var selectedTime = $scope.viewModel.selectedTime;
			if (angular.isUndefined(selectedTime)) {
				middleJSTime =  ($scope.viewModel.JSTimeFrom + $scope.viewModel.JSTimeTo) / 2.0;
			} else {
				middleJSTime = selectedTime.getTime();
			}
			var newDisplayTimeFrom = middleJSTime - newTimeOffset;
			var newDisplayTimeTo = middleJSTime + newTimeOffset;
			var newBrushDomainTimeFrom = middleJSTime - ($scope.data.queryFactor * newTimeOffset);
			var newBrushDomainTimeTo = middleJSTime + ($scope.data.queryFactor * newTimeOffset);
			
			var pause = false;
			var play = false;

			if (($scope.data.interval.JSTime <= maxAutoRefreshInterval) && (nextInterval.JSTime > maxAutoRefreshInterval)) {
				// pause auto-refresh for large intervals
				pause = true;
			} else if (($scope.data.interval.JSTime > maxAutoRefreshInterval) && (nextInterval.JSTime <= maxAutoRefreshInterval)) {
				play = true;
			}

			self.setBrushValues(newDisplayTimeFrom, newDisplayTimeTo, newBrushDomainTimeFrom, newBrushDomainTimeTo);
			$scope.data.interval = nextInterval;

			// triggering auto refresh should happen after new domain and intervals are set
			if (pause) {
				$scope.pauseAutoRefresh({reason: 'LargeInterval'});
			} else if (play) {
				$scope.playAutoRefresh({reason: 'LargeInterval'});
			}
		}
	};
	
	// button handlers
	$scope.jumpLeft = function() {
		if ($scope.viewModel.JSTimeFrom > $scope.viewModel.brushDomainStartTime) {
			jumpToWindowStart();
		} else {
			page('L');
		}		
	};
	
	$scope.jumpRight = function() {
		if ($scope.viewModel.JSTimeTo < $scope.viewModel.brushDomainEndTime) {
			jumpToWindowEnd();
		} else {
			page('R');
		}		
	};
	
	$scope.resetToDefault = function() {
		self.resetToDefault();	
	};

	// Checks if reset to disable link should be disabled
	$scope.disableResetToDefault = function() {
		var defaults = $scope.viewModel.defaultTimeSettings;
		return (($scope.data.interval.value === defaults.interval.value)
			&& ($scope.viewModel.JSTimeFrom === defaults.displayTimeFrom)
			&& ($scope.viewModel.JSTimeTo === defaults.displayTimeTo)
			&& ($scope.viewModel.brushDomainStartTime === defaults.windowTimeFrom)
			&& ($scope.viewModel.brushDomainEndTime === defaults.windowTimeTo));
	};
	
	$scope.toggleLegends = function() {
		$scope.viewModel.showLegend = !$scope.viewModel.showLegend;
		$scope.viewModel.legendsToggled = true;
	};
	
	$scope.getTimeHeaderContainerClass = function() {
		return TimelineService.getTimeHeaderContainerClass($scope.viewModel.showLegend);
	};
	
	$scope.getLegendContainerClass = function() {
		return TimelineService.getLegendContainerClass();
	};
	
	// Handles resize events, toggling legend and rescaling svg as necessary
	$scope.handleResize = $mdUtil.debounce(function() {
		self.toggleLegendOnResize();
		self.setTimeHeaderDimensions();
		$scope.$digest();
	}, 15);

	/// Hide all timelines that are showing. Otherwise show all.
	$scope.toggleAllCollapse = function() { 
		var someOpen = false;
		angular.forEach($scope.data.items, function(element) {
			someOpen = someOpen || (!element.collapsed && !element.hidden);
		});
		if (someOpen) { 
			angular.forEach($scope.data.items, function(element, index) {
				$scope.data.items[index].collapsed = true;
			});
		} else { 
			angular.forEach($scope.data.items, function(element, index) {
				$scope.data.items[index].collapsed = false;
			});
		}
	};

	// Used in timeline.html. User preferences should only be applied in the encounter record timeline view
	$scope.isInEncounterRecord = function() { 
		var encounterRecordTimeline = websysGetValue('TimelineID','epr.UPR.Composite');
		return encounterRecordTimeline !== '';
	};
	
	// Label to display on the collapse bar
	$scope.getItemLabel = function(timelineItem) { 
		return TimelineService.getItemLabel(timelineItem);
	};

	$scope.getCollapseBarIcon = function(isCollapsed) { 
		return TimelineService.getCollapseBarIcon(isCollapsed);
	};

	this.getOffsetTop = function(item) {
		var ret = item.offsetTop;
		while (item.offsetParent) {
			ret = ret + item.offsetParent.offsetTop;
			item = item.offsetParent;
		}
		return ret;
	};
	// event to reload all obervation timelines.
	$scope.$on('OBS:reload', function() {
		$scope.$broadcast('Timeline:reloadObs');
	});

	this.pausePlayAutoRefresh = function(data, play) {
		if ($scope.viewModel.autoRefresh.enabled) {
			// set a lock on the auto-refresh so that it does not trigger while this logic is happening
			$scope.viewModel.autoRefresh.lock = false;
			if (angular.isUndefined(data)) data = {reason: ''};
			if (data.reason === 'LargeInterval') {
				$scope.viewModel.autoRefresh.smallInterval = play;
			} else if (data.reason === 'Popover') {
				$scope.viewModel.autoRefresh.popoverInactive = play;
			} else if (data.reason === 'UserPref') {
				$scope.viewModel.autoRefresh.userPrefInactive = play;
			}
			if (play) {
				websysCallFunction('epr.UPR.Composite', 'PlayAutoRefresh', $scope.viewModel.autoRefresh);
			} else {
				websysCallFunction('epr.UPR.Composite', 'PauseAutoRefresh', $scope.viewModel.autoRefresh);
			}
			$scope.viewModel.autoRefresh.lock = true;
		}
	};

	$scope.pauseAutoRefresh = function(data) {
		self.pausePlayAutoRefresh(data, false);
	};

	$scope.playAutoRefresh = function(data) {
		self.pausePlayAutoRefresh(data, true);
	};

	this.checkAutoRefreshFlags = function() {
		/* Disabled when auto-refresh not configured
		Disabled when another component is loaded in work area for encounter actions 
		Disabled during one touch order session */
		if (!$scope.viewModel.autoRefresh.enabled) return false;
		/* Disabled when pauseAutoRefresh or playAutoRefresh is being called */
		if (!$scope.viewModel.autoRefresh.lock) return false;
		/* Disabled when pause button is clicked */
		if (!$scope.viewModel.autoRefresh.on) return false;
		/* Disabled when zoom interval is larger than supported for auto-refresh */
		if (!$scope.viewModel.autoRefresh.smallInterval) return false;
		/* Disabled when timeline popovers are active */
		if (!$scope.viewModel.autoRefresh.popoverInactive) return false;
		/* Disabled during user preference overlay */
		if (!$scope.viewModel.autoRefresh.userPrefInactive) return false;
		/* Extra check for one touch order session - in case it triggers before ShowOTO is called in websys.JS.epr.UPR.Composite */
		if (websysGetValue('IsRapidOrderView','epr.UPR.Composite')) return false;
		return true;
	};

	$scope.$on('Timeline:pauseAutoRefresh', function(evt, data) {
		$scope.pauseAutoRefresh(data);
	});

	$scope.$on('Timeline:playAutoRefresh', function(evt, data) {
		$scope.playAutoRefresh(data);
	});

	var getCurrentTime = function() {
		var currentDate = new Date();
		return (3600*currentDate.getHours()) + (60*currentDate.getMinutes()) + currentDate.getSeconds();
	};

	// triggered by auto-refresh interval lookup on epr.UPR.Composite
	$scope.handleAutoRefreshChange = function(interval) {
		if ($scope.viewModel.autoRefresh.enabled) {
			$scope.viewModel.autoRefresh.interval = interval;
		}
	};

	// triggered by auto-refresh play/pause icon on epr.UPR.Composite
	$scope.toggleAutoRefresh = function(on) {
		if ($scope.viewModel.autoRefresh.enabled) {
			$scope.viewModel.autoRefresh.on = on;
		}
	};

	// triggered when switching to and from timeline view on epr.UPR.Composite
	$scope.toggleAutoRefreshEnable = function(enable) {
		if ($scope.data.autoRefreshEnabled) $scope.viewModel.autoRefresh.enabled = enable;
	};

	$scope.triggerAutoRefresh = function() {
		if (self.checkAutoRefreshFlags()) {
			// check if time since last refresh is larger than refresh interval
			// autoRefreshInterval units is minutes
			if ((getCurrentTime() - $scope.viewModel.lastRefresh) > (60*$scope.viewModel.autoRefresh.interval)) {
				websysCallFunction('epr.UPR.Composite', 'RefreshTimeline', true);
			}
		}
	};

	$scope.$on('$destroy', function() {
		if (angular.isDefined($scope.viewModel.autoRefresh.timer)) {
			$interval.cancel($scope.viewModel.autoRefresh.timer);
		}
	});

	// Zoom to specific interval using the interval index
	$scope.zoomToInterval = function(intervalIndex) {
		// Zoom to the selected interval
		var interval = getInterval(intervalIndex);
		if (angular.isDefined(interval)) {
			zoomTo(interval);
		}
		
	};

	initialiseController();
});
